import { render, staticRenderFns } from "./CostumerRelation.vue?vue&type=template&id=deb8bc32"
import script from "./CostumerRelation.vue?vue&type=script&lang=js"
export * from "./CostumerRelation.vue?vue&type=script&lang=js"
import style0 from "./CostumerRelation.vue?vue&type=style&index=0&id=deb8bc32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports